/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-table-wrapper[_ngcontent-%COMP%]{padding:20px;background-color:#fff}table.custom-table[_ngcontent-%COMP%]{width:100%;margin:0}h1[_ngcontent-%COMP%]{letter-spacing:0;margin:0;text-align:center;border-top:1px solid #e6e6e6;padding:15px 0;background-color:#fff}.textUnderlined[_ngcontent-%COMP%]{border-bottom:1px dashed;cursor:pointer}"];
export { styles as styles };
